import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-fus-inicio',
  templateUrl: './fus-inicio.component.html',
  styleUrls: []
})
export class FusInicioComponent implements OnInit { 
      gestion: number = 0;
      gestionSiguiente: number = 0;
      techos: any[];
      baseUrl = environment.apiEndpoint;
      rol: number = 0;    

      constructor(private _gs: GeneralService) {
        this.gestion = parseInt(localStorage.getItem('g'));  
        this.gestionSiguiente = new Date().getFullYear() + 1;
        
        this.getTechoByUO();
         
         
      }
    
      ngOnInit() {
      }
    
      getTechoByUO() {
        let u = JSON.parse(localStorage.getItem('u'));
        this.rol = u.rol_id;
        if (u != null) {
          
          this._gs.getTechoByUO(u.unidad).subscribe(
            (response) => {
              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                this.techos = result.data;                
              } else {
                this.techos = [];
              }
            },
            (error) => { console.log('Error', error); });
        }
      }
    }
    